function loadInStoreEditInfo() {
    var $ = jQuery;
    // console.log('1');

    const location_id = localStorage.getItem('ecw_customer_store_location_id');
    const popup = $('#menu-select-order-type');

    $("#start-order-order-location-curbside-error").addClass("hide");
    $("#start-order-order-location-search").addClass("form-alert");
    $("#start-order-order-location-search-error-delivery").addClass("hide").removeAttr("tabindex");
    $("#start-order-order-location-search-error").addClass("hide").removeAttr("tabindex");

    if (location_id
        // && !popup.hasClass('loadedInfo')
    ) {
        // console.log('5');
        $backBtn = $("#menu-select-order-type [data-back-button]");
        $backBtn.click(function () {
            $('#menu-select-order-type').foundation('close');
                localStorage.removeItem('ecw_confirm_location');
      localStorage.removeItem('ecw_visitor_store_latitude');
      localStorage.removeItem('ecw_visitor_store_longitude');

        });
        // console.log('location_id', location_id);
        $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
                action: "olo_get_restaurant",
                restaurant_id: location_id,
                get_calendar: true,
                referer: window.location.href
            },
            success: function (response) {
                // console.log('response', response);
                try {

                    let results = JSON.parse(response);

                    if (!$('.accordion[data-all-hours]').length) {
                        getLocationHours(popup, results.calendars, location_id);
                    }

                    getLocationOrderTypes(popup, results);
                    showStoreOrderTypes(popup);
                    actionsOnChangingOrderType();
                    intializeDeliverySearchAddress();

                    const localStorageOrderType = localStorage.getItem('ecw_customer_deliverymode');
                    const localStorageOrderTime = localStorage.getItem('ecw_customer_schedule');
                    const localStorageOrderScheduledDay = localStorage.getItem('ecw_customer_scheduled_day');
                    const localStorageOrderScheduledTime = localStorage.getItem('ecw_customer_scheduled_time');
                    const localStorageCustomerLSAddress = localStorage.getItem("ecw_customer_address_streetaddress");
                    const localStorageCustomerLSCity = localStorage.getItem("ecw_customer_address_city");
                    const localStorageCustomerLSZip = localStorage.getItem("ecw_customer_address_zipcode");
                    const localStorageCustomerLSCarMake = localStorage.getItem("ecw_customer_car_make");
                    const localStorageCustomerLSCarModel = localStorage.getItem("ecw_customer_car_model");
                    const localStorageCustomerLSCarColor = localStorage.getItem("ecw_customer_car_color");

                    if (localStorageOrderType) {
                        popup.find('input#' + localStorageOrderType).click();
                    }

                    if (localStorageOrderTime === 'asap') {
                        popup.find('input#start-order-asap').click();
                    } else if (localStorageOrderTime) {
                        popup.find('input#start-order-scheduled').click();
                    }

                    if (localStorageOrderScheduledDay) {
                        popup.find(`select#start-order-time-wanted-day option[value="${localStorageOrderScheduledDay}"]`)
                            .prop('selected', true)
                            .trigger('change');
                    }

                    if (localStorageOrderScheduledTime) {
                        popup.find(`select#start-order-time-wanted-time-slot option[value="${localStorageOrderScheduledTime}"]`)
                            .prop('selected', true)
                            .trigger('change');
                    }

                    const $input = popup.find('input#start-order-order-location-search-delivery');
                    $input.val('');

                    if (
                        localStorageCustomerLSAddress &&
                        localStorageCustomerLSAddress !== 'undefined' &&
                        localStorageCustomerLSCity &&
                        localStorageCustomerLSCity !== 'undefined' &&
                        localStorageCustomerLSZip &&
                        localStorageCustomerLSZip !== 'undefined'
                    ) {
                        $input.focus();
                    }

                    if (
                        localStorageCustomerLSCarMake &&
                        localStorageCustomerLSCarModel &&
                        localStorageCustomerLSCarColor &&
                        localStorageOrderType === "curbside"
                    ) {
                        popup.find('#start-order-order-location-search-car-make').val(localStorageCustomerLSCarMake);
                        popup.find('#start-order-order-location-search-car-model').val(localStorageCustomerLSCarModel);
                        popup.find('#start-order-order-location-search-car-color').val(localStorageCustomerLSCarColor);
                    } else {
                        popup.find('#start-order-order-location-search-car-make').val("");
                        popup.find('#start-order-order-location-search-car-model').val("");
                        popup.find('#start-order-order-location-search-car-color').val("");
                    }

                    $('#menu-select-order-type .i-load').removeClass('i-load');

                    $("#menu-select-order-type[aria-hidden='false'] #menu-select-order-type-button")
                        .off("click") // remove any previous handlers
                        .on("click", function () {
                            // console.log('i start order?', $(this));

                            var validAddress = true;
                            var isDelivery = Boolean(
                                $('input[name="start-order-order-type"]:checked').val() == "dispatch"
                            );
                            var vendorid = results.id;
                            var supportsbaskettransfers = results.supportsbaskettransfers;

                            if (
                                isDelivery &&
                                !($("#start-order-order-location-search-delivery").val() || "").length
                            ) {
                                validAddress = false;
                            }

                            var validCurbside = true;
                            var isCurbside = Boolean(
                                $('input[name="start-order-order-type"]:checked').val() == "curbside"
                            );
                            if (isCurbside) {
                                if (
                                    !($("#start-order-order-location-search-car-make").val() || "").length ||
                                    !($("#start-order-order-location-search-car-model").val() || "").length ||
                                    !($("#start-order-order-location-search-car-color").val() || "").length
                                ) {
                                    validCurbside = false;
                                    validAddress = true;
                                } else {
                                    localStorage.setItem("ecw_customer_car_make", $("#start-order-order-location-search-car-make").val());
                                    localStorage.setItem("ecw_customer_car_model", $("#start-order-order-location-search-car-model").val());
                                    localStorage.setItem("ecw_customer_car_color", $("#start-order-order-location-search-car-color").val());
                                    validCurbside = true;
                                }
                            }

                            $("#start-order-order-location-search").removeClass("form-alert");
                            $("#start-order-order-location-search-error").addClass("hide").removeAttr("tabindex");

                            if (!validAddress) {
                                // console.log('invalid delivery address');
                                $("#start-order-order-location-search").addClass("form-alert");
                                $("#start-order-order-location-curbside-error").addClass("hide").removeAttr("tabindex");
                                $("#start-order-order-location-search-error").removeClass("hide").attr("tabindex", "-1").focus();
                            } else if (!validCurbside) {
                                // console.log('invalid curbside address');

                                $("#start-order-order-location-search").addClass("form-alert");
                                $("#start-order-order-location-search-error").addClass("hide").removeAttr("tabindex");
                                $("#start-order-order-location-curbside-error").removeClass("hide").attr("tabindex", "-1").focus();
                            } else {  
                                // console.log('valid curbside/delivery address');

                                ecw_show_loading();
                                setAddressComponents("start-order");
                                selectLocation(
                                    vendorid,
                                    supportsbaskettransfers,
                                    $('.wf-ordering-checkout').length > 0,
                                    "start-order"
                                );
                            }
                        });

                    // console.log('4');
                } catch (err) {
                    ecw_hide_loading();
                    console.error('Error inside success handler:', err);
                }
            },
            complete: function () {
                // console.log('✅ COMPLETE fired');
                ecw_hide_loading();
            },
            error: function (xhr, status, error) {
                console.log('❌ AJAX error:', status, error);
            }

        });
    } else if (!location_id) {
        change_view("start-order");
        ecw_hide_loading();
        // console.log('3');

    }
    // console.log('2');

}

function getOrderTypeEditPopupInfo() {
    var $ = jQuery;
    // console.log('i call');

    //get order type
    let customerLSdeliverymode = localStorage.getItem("ecw_customer_deliverymode");
    let presentationOfDeliveryMode = $("[data-local-storage-delivery-mode]");

    // console.log('customerLSdeliverymode', customerLSdeliverymode, presentationOfDeliveryMode);

    if (customerLSdeliverymode && customerLSdeliverymode.trim() !== "") {
        if (customerLSdeliverymode === "dispatch") {
            customerLSdeliverymode = "Delivery";
        }
        $("[data-local-storage-delivery-mode]").text(customerLSdeliverymode.charAt(0).toUpperCase() + customerLSdeliverymode.slice(1));
        $("[data-local-storage-delivery-mode]").removeClass('hide');
    } else {
        $("[data-local-storage-delivery-mode]").addClass('hide');
        // change_view('start-order');

    }
    const customerLSschedule = localStorage.getItem("ecw_customer_schedule");
    const customerLSscheduleDay = localStorage.getItem("ecw_customer_scheduled_day");
    const customerLSscheduleTime = localStorage.getItem("ecw_customer_scheduled_time");
    if (customerLSschedule && customerLSschedule.trim() !== "" && customerLSschedule === "asap") {
        $('[data-local-storage-delivery-timing]').text('ASAP')
    } else if (
        customerLSscheduleDay && customerLSscheduleDay.trim() !== "" &&
        customerLSscheduleTime && customerLSscheduleTime.trim() !== ""
    ) {
        // Convert time to 12-hour format
        const [hourStr, minute] = customerLSscheduleTime.split(":");
        let hour = parseInt(hourStr, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        const normalTime = `${hour}:${minute} ${ampm}`;

        // Convert day from yyyy-mm-dd to mm/dd/yyyy
        const [year, month, day] = customerLSscheduleDay.split("-");
        const formattedDate = `${month}-${day}-${year}`;

        $('[data-local-storage-delivery-timing]').text(` at ${normalTime} on ${formattedDate}`);
    }


    //get delivery address
    const customerLSAddress = localStorage.getItem("ecw_customer_address_streetaddress");

    if (typeof customerLSAddress !== "undefined" && customerLSAddress !== "undefined" && customerLSAddress && customerLSAddress.trim() !== "") {
        $('[data-delivery-location]').removeClass('hide');
        // console.log(customerLSAddress, $("[data-delivery-address]"));

        $("[data-delivery-address]").text(customerLSAddress);
        $("[data-delivery-city]").text(localStorage.getItem("ecw_customer_address_city"));
        $("[data-delivery-state-zip]").text(localStorage.getItem("ecw_customer_address_zipcode"));
    } else {
        $('[data-delivery-location]').addClass('hide');
    }


    //get store address 
    const customerLSStoreAddress = localStorage.getItem("ecw_customer_store_address");
    if (customerLSStoreAddress && customerLSStoreAddress.trim() !== "") {
        $('[data-menu-selected-store-address]').removeClass('hide');
        $('[data-menu-selected-store-address]').text(customerLSStoreAddress);
    } else {
        $('[data-menu-selected-store-address]').addClass('hide');
    }
    const customerLSStorePhone = localStorage.getItem("ecw_customer_store_phone");
    if (customerLSStorePhone && customerLSStorePhone.trim() !== "") {
        $('[data-menu-selected-store-phone]').removeClass('hide');
        // Create an anchor tag
        const $phoneLink = $('<a>');
        $phoneLink.attr('href', `tel:${customerLSStorePhone}`);
        $phoneLink.text(customerLSStorePhone);
        $('[data-menu-selected-store-phone]').empty().append($phoneLink);
    } else {
        $('[data-menu-selected-store-phone]').addClass('hide');
    }
}

